import { Component } from '@verndale/core';

class SeoHeader extends Component {
  setupDefaults() {
    this.dom = {};
  }

  addListeners() {
    const stick = this.el.dataset.sticky;

    if (stick === 'true') {
      this.el.classList.add('stick');
      window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
          this.el.classList.add('shadow');
        } else {
          this.el.classList.remove('shadow');
        }
      });
    }
  }
}

export default SeoHeader;
